// extracted by mini-css-extract-plugin
module.exports = {"credit":"Credit_credit__1VahW"};